__turbopack_context__.v({
  "col": "PlasmicFeaturesProductHeader-module__5S8nYq__col",
  "descriptionText": "PlasmicFeaturesProductHeader-module__5S8nYq__descriptionText",
  "logo__lVytp": "PlasmicFeaturesProductHeader-module__5S8nYq__logo__lVytp",
  "subtitleText": "PlasmicFeaturesProductHeader-module__5S8nYq__subtitleText",
});
